"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoveOrgMemberRequestStruct = void 0;
const superstruct_1 = require("superstruct");
exports.RemoveOrgMemberRequestStruct = (0, superstruct_1.type)({
    organisationId: (0, superstruct_1.string)(),
    userId: (0, superstruct_1.string)(),
});
//# sourceMappingURL=RemoveOrgMemberRequest.js.map